import React, { useState, Fragment } from 'react';
import DataTable from "react-data-table-component";
import { Link, useNavigate } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { Form } from 'react-bootstrap';

const UserList = () => {

    const navigate = useNavigate();

    const [userList] = useState([
        {
            "id": 0,
            "sno": 1,
            "sectiontitle": "Banner",
        },
        {
            "id": 1,
            "sno": 2,
            "sectiontitle": "second section",
        },
        {
            "id": 2,
            "sno": 3,
            "sectiontitle": "third section",
        },
        {
            "id": 3,
            "sno": 4,
            "sectiontitle": "fourth section",
        },
    ]);

    const columns = [
        {
            name: "S.no",
            align: "left",
            sortable: false,
            selector: row => row.sno

        },
        {
            name: "Section Title",
            align: "left",
            sortable: false,
            selector: row => row.sectiontitle

        },
        {
            name: "Action",
            align: "left",
            sortable: false,
            cell: record => {
                return (
                    <Fragment>
                        <button
                            className={`btn sitebtn btn-sm ${record.id}`}
                            onClick={() => navigate("/userEdit")}
                        >
                            <FaEdit />
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    return (
        <div className="cmslist">
            <h1 className="pagehead">User List</h1>
            <div className="cardbox">
                <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
                    <Form>
                        <Form.Control type="text" placeholder="Search" />
                    </Form>
                    <Link to="/useradd" className="btn sitebtn">Add</Link>
                </div>
                <div className="tablebox">
                    {/* <Form.Control type="text" placeholder="Filter in records" /> */}
                    <DataTable
                        className='react-datatables'
                        columns={columns}
                        data={userList}
                        pagination // Enable pagination
                        // paginationPerPage={2} // Rows per page
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserList;